import { t } from 'i18next';

import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { ImportArgument, DialogActions } from './DialogActions';
import { UIHelper } from '../utils/UIHelper';
import { GlobalHelper } from '../utils/GlobalHelper';
import { SceneActions } from './SceneActions';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { ArticleStore, ArticleItem } from '../stores/ArticleStore';
import { ScreenshotHelper } from '../utils/ScreenshotHelper';
import { Stats } from '../utils/Stats';

import cf = egr.wcf.cf;
import utils = egr.wcf.utils;
import eaiws = egr.wcf.eaiws;

export abstract class ArticleActions {
    private static sLastInvalidation: number = 0;
    private static sArticleImageOptions: cf.ArticleScreenshotOptions = {
        width: 48 * 2,
        height: 48 * 2,
        margin: 0,
        hideSubArticles: true
    };

    public static importTypical(fileInput: HTMLInputElement): void {
        let correctFileType: boolean = false;
        try {
            const files: FileList | null = fileInput.files;
            if (files != null) {
                const inputFile: File | null = files.item(0);
                if (inputFile != null) {
                    const fileImportArgument: ImportArgument = DialogActions.fileToImportArgument(inputFile);
                    correctFileType = fileImportArgument.type === 'PEC';
                    if (correctFileType) {
                        if (!GlobalHelper.eaiwsSession.isValid) {
                            DialogActions.openProjectFromFileInput(fileInput);
                        } else {
                            Stats.sendEvent({
                                action: 'Plandat'
                            });
                            SceneActions.importPecFile(inputFile);
                        }
                    }
                }
            }
        } catch (e) {
            correctFileType = false;
        }
        if (!correctFileType) {
            UIHelper.showMessage(t('This file can not be imported. You can import PEC files only.'));
        }
    }

    public static invalidateArticleList(skipSynchronize: boolean = false): void {
        ArticleActions.sLastInvalidation = Date.now();
        AppDispatcher.dispatch({
            actionType: ActionConstants.ARTICLE_LIST_CHANGED
        });

        if (AppConfigurationStore.getState().inApp && skipSynchronize === false) {
            GlobalHelper.articleManager.synchronizeSession(true);
        }
    }

    public static updateArticleList(checkState: boolean = false): Promise<void> {
        if (checkState === true && ArticleStore.getState().needsUpdate === false) {
            return Promise.resolve();
        }

        const articles: Array<cf.ArticleElement> = new Array<cf.ArticleElement>();
        const mainArticles: Array<cf.MainArticleElement> = GlobalHelper.articleManager.getAllMainArticles();
        for (const article of mainArticles) {
            articles.push(article);
            // add sub articles
            utils.array.addElements(articles, article.getSubArticles(false));
        }

        const updateStartTime: number = Date.now();
        const articleListData: Array<ArticleItem> = new Array<ArticleItem>();
        return utils.async.forEach(articles, false, async (index: number, article: cf.ArticleElement): Promise<boolean> => {
            const properties: eaiws.basket.ItemProperties = await article.getItemProperties();

            if (properties != null) {
                const image: string | null = await ScreenshotHelper.getArticleImage(
                    article,
                    ArticleActions.sArticleImageOptions
                );

                articleListData.push({
                    article: article,
                    properties: properties,
                    image: image,
                });
            }

            return true;
        }).then(() => {
            AppDispatcher.dispatch({
                actionType: ActionConstants.ARTICLE_LIST_UPDATE,
                value: articleListData
            });

            if (updateStartTime < ArticleActions.sLastInvalidation) {
                setTimeout(ArticleActions.invalidateArticleList, 0);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/ArticleActions.ts